import { Box } from '@chakra-ui/react';
import { useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { insertInto } from '../FormEditor/Editor/editorSlice';

const DragTypes = {
  FIELD: 'field',
};
const SidebarField = ({ type, text }) => {
  const dispatch = useDispatch();

  const [, drag] = useDrag({
    type: DragTypes.FIELD,
    item: () => ({ type }),
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult && item.dropIndex !== undefined) {
        dispatch(insertInto({ pos: item.dropIndex, type: item.type }));
      }
    },
  });

  return (
    <Box
      cursor="grab"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="8px"
      fontSize="sm"
      px="4"
      py="1.5"
      ref={drag}
      _hover={{ bg: 'gray.50' }}
    >
      {text}
    </Box>
  );
};
export default SidebarField;
